/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CursorPaginationDto } from '../models/cursor-pagination-dto';
import { tokenControllerGetTokenInfo } from '../fn/token/token-controller-get-token-info';
import { TokenControllerGetTokenInfo$Params } from '../fn/token/token-controller-get-token-info';
import { tokenControllerSearchCursorTokenLogs } from '../fn/token/token-controller-search-cursor-token-logs';
import { TokenControllerSearchCursorTokenLogs$Params } from '../fn/token/token-controller-search-cursor-token-logs';
import { TokenInfoDto } from '../models/token-info-dto';

@Injectable({ providedIn: 'root' })
export class TokenService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `tokenControllerGetTokenInfo()` */
  static readonly TokenControllerGetTokenInfoPath = '/api/token';

  /**
   * 토큰 정보를 가져옵니다.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tokenControllerGetTokenInfo()` instead.
   *
   * This method doesn't expect any request body.
   */
  tokenControllerGetTokenInfo$Response(params: TokenControllerGetTokenInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<TokenInfoDto>> {
    return tokenControllerGetTokenInfo(this.http, this.rootUrl, params, context);
  }

  /**
   * 토큰 정보를 가져옵니다.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tokenControllerGetTokenInfo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tokenControllerGetTokenInfo(params: TokenControllerGetTokenInfo$Params, context?: HttpContext): Observable<TokenInfoDto> {
    return this.tokenControllerGetTokenInfo$Response(params, context).pipe(
      map((r: StrictHttpResponse<TokenInfoDto>): TokenInfoDto => r.body)
    );
  }

  /** Path part for operation `tokenControllerSearchCursorTokenLogs()` */
  static readonly TokenControllerSearchCursorTokenLogsPath = '/api/token/log/cursor';

  /**
   * 토큰 로그를 커서 기반으로 검색합니다.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tokenControllerSearchCursorTokenLogs()` instead.
   *
   * This method doesn't expect any request body.
   */
  tokenControllerSearchCursorTokenLogs$Response(params: TokenControllerSearchCursorTokenLogs$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto>> {
    return tokenControllerSearchCursorTokenLogs(this.http, this.rootUrl, params, context);
  }

  /**
   * 토큰 로그를 커서 기반으로 검색합니다.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tokenControllerSearchCursorTokenLogs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tokenControllerSearchCursorTokenLogs(params: TokenControllerSearchCursorTokenLogs$Params, context?: HttpContext): Observable<CursorPaginationDto> {
    return this.tokenControllerSearchCursorTokenLogs$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto>): CursorPaginationDto => r.body)
    );
  }

}
